import * as React from 'react';
import SvgIcon from "presentation/common/components/style-guide/svg-icon/SvgIcon";

export const SignInMailIcon = (props) => {
  const {fill = '#fff', stroke = '#fff' } = props;
  return (
    <SvgIcon className="icon" {...props} style={{fill, stroke, strokeWidth: '2px'}} width="74.867" height="56.151" viewBox="0 0 74.867 56.151">
        <g id="Group_3379" data-name="Group 3379" transform="translate(-2 -4)">
          <path id="Path_816" data-name="Path 816" d="M2,12.814,39.421,31.522,76.84,12.813A9.359,9.359,0,0,0,67.5,4H11.346A9.359,9.359,0,0,0,2,12.814Z" transform="translate(0.012)" fill={fill}/>
          <path id="Path_817" data-name="Path 817" d="M76.867,8.118,39.433,26.835,2,8.118V35.642A9.358,9.358,0,0,0,11.358,45H67.509a9.358,9.358,0,0,0,9.358-9.358Z" transform="translate(0 15.151)" fill={fill} />
        </g>
    </SvgIcon>
  );
};

export default SignInMailIcon;
